import { render, staticRenderFns } from "./generalInfoForm.vue?vue&type=template&id=73f7bd0b"
import script from "./generalInfoForm.vue?vue&type=script&lang=js"
export * from "./generalInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports